import { useDialog, useScope } from '@mews/framework';
import { Card, EmptyState, Link } from '@optimus-web/core';
import { LocalizedParagraph, LocalizedSmallParagraph } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { useCommanderSelector } from '@mews-commander/utils';
import { getAccountIds } from '../../../ducks/billing';
import { AddBillDialog } from '../../../BillNameDialog/AddBillDialog';

export const AccountBillCardEmptyState = () => {
    const scope = useScope() ?? '';
    const accountId = useCommanderSelector((state) => getAccountIds(state, { scope })[0]);

    const [{ onClose, active }, toggleDialog] = useDialog();

    return (
        <Card>
            <AddBillDialog active={active} onClose={onClose} accountId={accountId} />
            <EmptyState
                primaryText={<LocalizedParagraph textKey={TextKey.NoOpenBills} />}
                secondaryText={<LocalizedSmallParagraph textKey={TextKey.NoOpenBillsSubtitle} />}
                action={
                    <Link onClick={toggleDialog}>
                        <LocalizedParagraph textKey={TextKey.CreateNewBill} />
                    </Link>
                }
            />
        </Card>
    );
};
